const APP_TITLE = "Parts Companion";

const stripPrefix = (title: string) => {
    const prefix = `${APP_TITLE} - `;
    return title.startsWith(prefix) ? title.slice(prefix.length).trim() : title;
};

const stripSuffix = (title: string) => {
    const suffix = ` - ${APP_TITLE}`;
    return title.endsWith(suffix)
        ? title.slice(0, -suffix.length).trim()
        : title;
};

export function normalizeStandalonePwaTitle(title: string) {
    const trimmedTitle = title.trim();
    if (!trimmedTitle || trimmedTitle === APP_TITLE) return trimmedTitle;

    const normalizedTitle = stripSuffix(stripPrefix(trimmedTitle)).trim();
    return normalizedTitle || trimmedTitle;
}
